import { FormStructure } from '@europrocurement/flexy-form';

/**
 * Form structure for antenna creation form and modification form
 * @returns antennaFormStructure : array of type FormStructure that create the antenna form
 */
export const getAntennaFormStructure = () => {
    const antennaFormStructure: FormStructure[] = [
        {
            type: 'header',
            label: "Modification de l'antenne",
            name: 'header',
        },
        {
            type: 'text',
            name: 'libelle',
            fullWidth: true,
            inputlabel: 'Libellé',
            rules: {
                required: true,
            },
            lg: 12,
            md: 12,
            sm: 12,
        },
    ];
    return antennaFormStructure;
};

export const getAntennaCreationFormStructure = () => {
    const antennaCreationFormStructure: FormStructure[] = [
        {
            type: 'text',
            name: 'idAntenne',
            fullWidth: true,
            inputlabel: 'ID',
            placeholder: 'Automatique',
            disabled: true,
            lg: 3,
            md: 3,
            sm: 3,
        },
        {
            type: 'text',
            name: 'libelle',
            fullWidth: true,
            inputlabel: 'Libellé',
            rules: {
                required: true,
            },
            lg: 6,
            md: 6,
            sm: 12,
        },
        {
            type: 'text',
            name: 'isDeleted',
            inputlabel: 'Statut',
            disabled: true,
            placeholder: 'Active',
            lg: 3,
            md: 3,
            sm: 3,
        },
    ];
    return antennaCreationFormStructure;
};
